export function mapParameters(integration, queryParams) {
  for (const param of integration.parameters) {
    if (param.name in queryParams) {
      param.value = queryParams[param.name];
    } else if (param.mapping[0] in queryParams) {
      const regex = new RegExp(param.mapping[1]);
      param.value = regex.exec(queryParams[param.mapping[0]])[1];
    }
  }

  integration.url = integration.parameters
    .reduce((agg, param) => agg.replace(`{${param.name}}`, param.value), integration.url);

  return integration;
}


export function processOAuth(integration, queryParams) {
  const { url } = mapParameters(integration, Object.fromEntries(queryParams));

  window.location.href = url;
}
